import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "outer" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MagnifyIcon = _resolveComponent("MagnifyIcon")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_ClusterGrid = _resolveComponent("ClusterGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NcTextField, {
        autofocus: true,
        modelValue: _ctx.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
        label: _ctx.t('memories', 'Search'),
        placeholder: _ctx.t('memories', 'Search')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MagnifyIcon, { size: 16 })
        ]),
        _: 1
      }, 8, ["modelValue", "label", "placeholder"])
    ]),
    (_ctx.list)
      ? (_openBlock(), _createBlock(_component_ClusterGrid, {
          key: 0,
          items: _ctx.filteredList,
          maxSize: 120,
          link: false,
          plus: _ctx.plus,
          onClick: _ctx.click,
          onPlus: _ctx.addFace
        }, null, 8, ["items", "plus", "onClick", "onPlus"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.t('memories', 'Loading …')), 1))
  ]))
}